import React, { useEffect, useState } from 'react';
import { Routes } from '../CSIRouter.tsx';
import { CrumbContext } from './CrumbContextContext';

export type Breadcrumb = {
  path: string;
  label: string;
};

export function CrumbProvider({ children }: { children: React.ReactNode }) {
  // functions and stuff to keep track of
  const defaultCrumb: Breadcrumb[] = [];
  const [crumbs, setCrumbs] = useState(defaultCrumb);

  useEffect(() => {
    const potentialCrumbList = sessionStorage.getItem('crumbs');
    if (potentialCrumbList) {
      setCrumbs(JSON.parse(potentialCrumbList));
    }
  }, []);

  // add crumb if it's not already in the list
  const addCrumb = (crumb: Breadcrumb, location: string) => {
    if (location.substring(1) === Routes.Root.Landing.path) {
      removeCrumbs(crumb.path);
    } else {
      removeCrumbs(location);
    }
    const newCrumbs = [...crumbs];
    let sameLabel: boolean = false;
    let foundIndex = -1;
    let index = 0;
    let found: boolean = false;
    if (crumb !== undefined && crumb.label.includes('Decarbonization')) {
      for (let i = newCrumbs.length - 1; i > -1; i--) {
        if (
          newCrumbs[i].label.includes('Decarbonization') &&
          newCrumbs[i].label !== crumb.label
        ) {
          newCrumbs.splice(i, 1);
        }
      }
    }
    for (const curCrumb of newCrumbs) {
      if (curCrumb.path === crumb.path && curCrumb.label === crumb.label) {
        found = true;
        break;
      } else if (curCrumb.path === crumb.path) {
        sameLabel = true;
        foundIndex = index;
      }
      index++;
    }
    if (sameLabel && foundIndex !== -1) {
      newCrumbs.splice(foundIndex, 1, crumb);
    } else if (!found) {
      newCrumbs.push(crumb);
    }
    const listAsString = JSON.stringify(crumbs);
    const newCrumbsAsString = JSON.stringify(newCrumbs);
    if (!(newCrumbsAsString === listAsString)) {
      sessionStorage.setItem('crumbs', newCrumbsAsString);
      setCrumbs([...newCrumbs]);
    }
  };

  // reset crumbs based on location
  const removeCrumbs = (location: string) => {
    let index = -1;
    let cur = 0;
    const newCrumbs = [...crumbs];
    for (const path of newCrumbs) {
      if (path.path === location) {
        index = cur;
        break;
      }
      cur++;
    }
    const toRemove = newCrumbs.length - index;
    // if index is still -1, we haven't reached this page before
    if (index > -1) {
      newCrumbs.splice(index + 1, toRemove);
      const listAsString = JSON.stringify(crumbs);
      const newCrumbsAsString = JSON.stringify(newCrumbs);
      if (!(newCrumbsAsString === listAsString)) {
        sessionStorage.setItem('crumbs', newCrumbsAsString);
        setCrumbs([...newCrumbs]);
      }
    }
  };

  return (
    //pass functions and stuff you want access to in the other files here (between the yellow curly brackets)
    <CrumbContext.Provider value={{ crumbs, addCrumb }}>
      {children}
    </CrumbContext.Provider>
  );
}
